(function ($, Drupal) {
  Drupal.behaviors.customScrollBehavior = {
    attach: function (context, settings) {
      // Function to handle scroll and click events
      function scrollTo() {
        // Use context consistently
        var id = $(".scroll-down-wrap a", context);
        var itemid = id.attr("href").split("#");
        $(".field__item:has(.news-wrapper)", context).attr("id", itemid[1]);

        // Event delegation for click event
        $(context).on("click", ".scroll-down-wrap a", function () {
          $(this).closest(".field__item").css({
            'font-size': '0',
            'width': '0',
            'height': '0',
            'overflow': 'hidden'
          });
        });
      }

      // Scroll event listener
      //var distance = $('.path-frontpage .field--name-field-paragraphs > .field__item:has(.news-wrapper)', context).offset().top - 120,
      var $element = $('.path-frontpage .field--name-field-paragraphs > .field__item:has(.news-wrapper)', context);

      if ($element.length > 0) {
          var offset = $element.offset();
          if (offset) {
              var distance = offset.top - 120;
          } else {
              console.error('Offset is undefined');
          }
      }

      $window = $(window);

      $window.scroll(function () {
        if ($window.scrollTop() >= distance) {
          $('.path-frontpage .field--name-field-paragraphs > .field__item:has(.scroll-down-wrap)', context).css({
            'font-size': '0',
            'width': '0',
            'height': '0',
            'overflow': 'hidden'
          });
        }
      });

      function updatesCustomScroll() {
        $('#news_update > .paragraph > .paragraph-content').mCustomScrollbar("destroy");
        $('#news_update > .paragraph > .paragraph-content').mCustomScrollbar({
          theme: "dark-thin",
          scrollButtons: {
            enable: true
          },
          advanced: {
            autoScrollOnFocus: false,
          }
        });
      }

      function parentClick() {
        $('.benner_right_item-wrap').on('click', function(event) {
          event.preventDefault(); // Prevent default behavior
          event.stopPropagation(); // Prevent event bubbling
  
          const link = $(this).find('.load-more a');
          const href = link.attr('href');
          const target = link.attr('target');
  
          // Open the link based on the target attribute
          if (target === '_blank') {
              window.open(href, '_blank');
          } else {
              window.location.href = href;
          }
        });
      }

      // Initialize on context ready
      $(context).ready(function () {
        scrollTo();
        updatesCustomScroll();
        parentClick();
      });
    }
  };
})(jQuery, Drupal);

